import type { DynamicDropdownQuery, DynamicDropdownScope } from '../models/dynamicDropdowns.types'
import type { ReportFilter } from '../models/filter.types'

export function dynamicDropdownUrl(scope: DynamicDropdownScope): string {
  return `/accounts/${encodeURIComponent(String(scope.accountId))}/workspaces/${encodeURIComponent(
    String(scope.workspaceId),
  )}/v1/controller/dropdowns`
}

function serializeFilter(filter: ReportFilter): Record<string, unknown> {
  return { field: filter.field, match_mode: filter.match_mode, value: filter.value }
}

export function buildDynamicDropdownQuery(query: DynamicDropdownQuery): string {
  const params = new URLSearchParams({
    partition_name: query.partition_name,
    date_start: query.date_start,
    date_end: query.date_end,
  })
  params.set('dimensions', JSON.stringify([...query.dimensions]))
  params.set('filters', JSON.stringify(query.filters.map(serializeFilter)))
  return params.toString()
}
